import type {ComponentType} from 'react'
import type {BgColor, FoniRow} from '../lvs-foni'
import type {ArrowDirection} from '../lvs-arrow'

export type SignCode = '521' | '705'

export interface SignInput {
    readonly rows: readonly FoniRow[]
    readonly bgColor: BgColor
    readonly strike: boolean
    /**
     * Outer width in mm. Acts as a *floor* for the computed background:
     * when the text-derived auto width exceeds it, the auto value wins.
     * The catalog default seeds this with the LVS 77-3:2016 §9.19 floor
     * (1000 mm for 521/522).
     */
    readonly outerWidth: number
    /** See `outerWidth`. §9.19 floor for 521/522 is 400 mm. */
    readonly outerHeight: number
    /**
     * Direction of the horizontal arrow on signs that host one (sign
     * 705). Absent on signs without an arrow (e.g. 521). When defined,
     * `computeSignLayout` reserves the arrow zone and emits an arrow
     * placement.
     */
    readonly arrowDirection?: ArrowDirection
}

export interface CustomStepProps {
    readonly input: SignInput
    readonly onChange: (patch: Partial<SignInput>) => void
}

export type WizardStepDef =
    | {readonly kind: 'content'}
    | {readonly kind: 'size'}
    | {
          readonly kind: 'background'
          readonly allowBgColors: readonly BgColor[]
          readonly allowStrike: boolean
      }
    | {readonly kind: 'arrow'}
    | {readonly kind: 'preview'}
    | {readonly kind: 'export'}
    | {
          readonly kind: 'custom'
          readonly id: string
          readonly title: string
          readonly Component: ComponentType<CustomStepProps>
      }

export interface SignDef {
    readonly code: SignCode
    readonly label: string
    readonly lvsRefs: readonly string[]
    readonly minSize: {readonly w: number; readonly h: number}
    readonly defaults: SignInput
    readonly steps: readonly WizardStepDef[]
}

export function stepTitle(step: WizardStepDef): string {
    switch (step.kind) {
        case 'content':
            return 'Saturs'
        case 'size':
            return 'Izmērs'
        case 'background':
            return 'Fons'
        case 'arrow':
            return 'Virziens'
        case 'preview':
            return 'Priekšskatījums'
        case 'export':
            return 'Eksports'
        case 'custom':
            return step.title
    }
}
